/**
 * videoViewRouting.js · which video page a device gets (Release C, punchlist 3.2).
 *
 * The page follows two inputs only, both fixed for the session:
 *   player · the DRM engine ('videojs' = FairPlay, otherwise Widevine)   → which engine's page
 *   device · the hardware class ('phone' | 'tablet' | 'desktop')         → which layout
 *
 * Window width is deliberately NOT an input. Since Release B2 the desktop page has its own very small layout
 * and the tablet page its narrow layout, so a narrow desktop window, an iPad mini, a small Android tablet and
 * Split View all keep their own page, and rotating a tablet never swaps the page under a playing video.
 * (Before Release C, AppLayout's isMobile, width under 768 px, also forced the phone page.)
 */
export function pickVideoPage(player, device) {
  const isPhone = device === 'phone';
  const isTabletDevice = !isPhone && device === 'tablet';
  if (player === 'videojs') {
    if (isPhone) return 'VideoViewPageFairPlayMobile';
    if (isTabletDevice) return 'VideoViewPageFairPlayTablet';
    return 'VideoViewPageFairPlay';
  }
  // Widevine, and the fallback for any unexpected `player` value.
  if (isPhone) return 'VideoViewPageMobile';
  if (isTabletDevice) return 'VideoViewPageTablet';
  return 'VideoViewPage';
}

export default pickVideoPage;
